import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Grid, GridColumn } from 'telia-front-react';
import config from '../../Config';
import LanguageStore from '../../stores/LanguageStore';

import { TranslationsContext } from '@teliaee/telia-translate';
import { Branch } from '../common/ReservationInterfaces';

interface ArrivalInformationLinkProps {
  branch: Branch;
  languageStore?: LanguageStore;
}

const ArrivalInformationLink = (props: ArrivalInformationLinkProps): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const {
    branch,
    languageStore: { currentLanguage }
  } = props;

  return (
    <Grid>
      <GridColumn width={['xs']}>
        <Button
          text={translate('branch.arrivalInformation')}
          url={`${config.teliaWebUrl}/${currentLanguage}/kontaktid/esindused/ligipaasetavus?branchId=${branch.branchId}`}
          link={true}
          iconRight="#arrow-right"
          block={true}
          external={true}
        />
      </GridColumn>
    </Grid>
  );
};

export default inject('languageStore')(observer(ArrivalInformationLink));
